import { useAtomValue, useSetAtom } from "jotai";

import { contactForm, contactFormSyncEffect } from "../stores";

export function useContactForm() {
  // Mount the sync effect
  useAtomValue(contactFormSyncEffect);

  // Actions
  const reset = useSetAtom(contactForm.actions.reset);
  const submit = useSetAtom(contactForm.actions.submit);

  return {
    contactForm,
    reset,
    submit,
  };
}
